import styled from 'styled-components';
import { ChipStyleMixin } from 'shared/styles';

export const StyledBlockedTopic = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: ${({ height }) => height || '100%'};
  overflow: auto;
  flex: 1;
  border-radius: 5px;
  text-overflow: ellipsis;
  .topic-multiselect {
    flex-grow: 1;
  }
  .blocked-keywords-container {
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
  }
  .blocked-keyword {
    ${ChipStyleMixin}
    color: #12344D;
    font-weight: 400;
    padding: 6px 12px;
    line-height: 16px;
    border: 1px solid #cfd7df;
    border-radius: 4px;
    display: flex;
    align-items: center;
    max-width: 100%;
    word-break: break-word;
    gap: 6px;
    .delete-icon {
      cursor: pointer;
      min-height: 10px;
      min-width: 10px;
    }
  }
  .topic-loader {
    height: 1005;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .search-input {
    height: 100%;
    &:focus {
      border-color: red;
    }
  }
  .search-icon {
    color: #264966;
    padding-left: 10px;
    padding-top: 5px;
  }
`;

export const StyledBlockedTopicPopover = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 16px rgba(18, 52, 77, 0.16);
  border-radius: 4px;
  width: 360px;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  padding: 12px;
  gap: 2px;

  .topic-header {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #475867;
  }
  .footer-buttons {
    display: flex;
    justify-content: end;
    gap: 8px;
    padding: 18px 0 4px;

    & button {
      width: fit-content;
      min-width: 70px;
      padding: 4px 8px;
      line-height: 14px;
    }
  }
  .svg-wrapper {
    display: none;
  }
  div[id='dropdownField container'] {
    min-height: 140px;
    overflow: auto;
    .items {
      position: absolute;
      top: 0;
      padding-top: 10px;
      width: calc(100% - 16px);
    }
  }
`;
